import request from '@/utils/request'

export function findCpeSuppliers(params) {
  return request({
    url: `/cpe_suppliers`,
    method: 'get',
    params
  })
}

export function findCpeSupplier(id) {
  return request({
    url: `/cpe_suppliers/${id}`,
    method: 'get'
  })
}

export function findCpeSupplierName(id) {
  return request({
    url: `/cpe_suppliers/${id}/name`,
    method: 'get'
  })
}

export function findCpeSupplierForm(id) {
  return request({
    url: `/cpe_suppliers/${id}/form`,
    method: 'get'
  })
}

export function findCpeSupplierCpes(id, params) {
  return request({
    url: `/cpe_suppliers/${id}/cpes`,
    method: 'get',
    params
  })
}

export function createCpeSupplier(data) {
  return request({
    url: `/cpe_suppliers`,
    method: 'post',
    data
  })
}

export function updateCpeSupplier(id, data) {
  return request({
    url: `/cpe_suppliers/${id}`,
    method: 'put',
    data
  })
}
